import { useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { useApiContext } from 'context/ApiContext';
import { useShowError } from 'hooks/useShowError';

export function useDeleteSubgrupo() {
    const { showError } = useShowError();
    const { api } = useApiContext();
    const queryClient = useQueryClient();

    /**
     * Exclui o o subgrupo e atualiza a lista de subgrupos.
     */
    const handleDelete = (idSubgrupo: number) => {
        api.delete(`/dre/dremercadologicagrupoexibicao/${idSubgrupo}`)
            .then(() => {
                queryClient.invalidateQueries(['querySubgrupos']);

                enqueueSnackbar('Subgrupo removido com sucesso', { variant: 'success' });
            })
            .catch((error) => showError(error, 'Falha ao remover o subgrup. Tente novamente'));
    };

    return { handleDelete };
}
